import { useState, useCallback } from 'react';
import { DeploymentLocks } from '../types/deployment';

export const useDeploymentLocks = (initialLocks: DeploymentLocks = {}) => {
  const [locks, setLocks] = useState<DeploymentLocks>(initialLocks);

  const toggleLock = useCallback((service: string) => {
    setLocks(prev => ({
      ...prev,
      [service]: !prev[service],
    }));
  }, []);

  const setLock = useCallback((service: string, isLocked: boolean) => {
    setLocks(prev => ({
      ...prev,
      [service]: isLocked,
    }));
  }, []);

  const isLocked = useCallback(
    (service: string): boolean => {
      return locks[service] || false;
    },
    [locks],
  );

  return {
    locks,
    toggleLock,
    setLock,
    isLocked,
  };
};
